import { render, staticRenderFns } from "./forbidden_list.vue?vue&type=template&id=62e4c6d7&scoped=true&"
import script from "./forbidden_list.vue?vue&type=script&lang=js&"
export * from "./forbidden_list.vue?vue&type=script&lang=js&"
import style0 from "./forbidden_list.vue?vue&type=style&index=0&id=62e4c6d7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e4c6d7",
  null
  
)

export default component.exports